















































import { Component, Vue } from "vue-property-decorator";
import NavigationList from "@/components/NavigationList.vue";
import NavigationListMobile from "@/components/NavigationListMobile.vue";
import { AuthService } from "./services/authService";
import LocaleChanger from "@/components/LocaleChanger.vue";
import Snackbar from "@/components/Snackbar.vue";

@Component({
    components: {
        NavigationList,
        NavigationListMobile,
        LocaleChanger,
        Snackbar,
    },
})
export default class App extends Vue {
    public mounted() {
        this.$auth.$watch("loading", loading => {
            if (loading === false) {
                this.loadUserToStore();
            }
        });
        const currentLog = console.error;
        console.error = (msg: unknown[]) => {
            if (msg !== undefined) {
                this.$store.commit("addConsoleLog", { payload: msg });
            }
            currentLog(msg);
        };
    }

    public async loadUserToStore() {
        if (this.$auth.isAuthenticated) {
            const token = await this.$auth.getTokenSilently();
            const user = await AuthService.getUser(token);
            this.$store.commit("setUser", { user });
            // TODO find better way to refresh token after first signup
            this.$auth.getTokenSilently({ ignoreCache: true });
        }
    }

    public get snackbar(): {
        text: string;
        color: string;
        value: string;
        trigger: boolean;
        timeout: number;
    } {
        return this.$store.state.snackbar;
    }

    public onSnackbarInput(value: boolean) {
        this.$store.commit("setSnackbarValue", { value });
    }

    public hideSnackbar() {
        this.$store.commit("hideSnackbar");
    }
}
